;(() => {
  const filterToggle = document.getElementById('collection-filter-toggle')

  if (filterToggle) {
    const filterElement = document.getElementById('collection-filter')
    const toggleFilter = (isOpen) => {
      filterElement.classList.toggle('open', isOpen)
      document.body.classList.toggle('menu-open', isOpen)
    }

    filterToggle.addEventListener('click', () => toggleFilter(true))

    document
      .querySelectorAll(
        '#collection-filter-close, #filter-background, .close-filters'
      )
      .forEach((element) => {
        element.addEventListener('click', () => toggleFilter(false))
      })
  }
})()
